
export default {
  name: 'BannerHeroCards',

  props: {
    title:      { type: String, default: 'Get TEFL<br>certified today' },
    text:       { type: String, default: 'Learn how to teach English abroad and online with our globally-renowned TEFL courses.' },
    buttonText: { type: String, default: 'Find my course' },
    url:        { type: String, default: '/courses/' },

    /* Left column — two cards, bottom one bleeds off-screen */
    colOne: {
      type: Array,
      default () {
        return [
          { title: '120-hour Premier Online Course',  priceOriginal: '£379.00', priceSale: '£151.60', image: 'https://cdn-wp.tefl.org/wp-content/uploads/2026/04/Thomas-Bailes-Collins-opt.jpg' },
          { title: '140-hour Premier Combined Course',  priceOriginal: '£449.00', priceSale: '£179.60', image: 'https://cdn-wp.tefl.org/wp-content/uploads/2026/04/Solene-Mondoux-opt.jpeg' },
        ]
      }
    },

    /* Right column — top card bleeds off above, second card visible mid-banner */
    colTwo: {
      type: Array,
      default () {
        return [
          { title: '250-hour Online Level 5 Diploma', priceOriginal: '£606.00', priceSale: '£242.40', image: 'https://cdn-wp.tefl.org/wp-content/uploads/2026/04/Alex-Chaderton.jpeg' },
          { title: '270-hour Combined Level 5 Diploma',  priceOriginal: '£520.00', priceSale: '£208.00', image: 'https://cdn-wp.tefl.org/wp-content/uploads/2026/03/120hr-2026-hero.jpg' },
        ]
      }
    },
  },

  data () {
    return {
      colOneOffset: 0,
      colTwoOffset: 0,
      ticking: false,
    }
  },

  computed: {
    /* Interleave cols so mobile scroll order is col1[0], col2[0], col1[1], col2[1] */
    allCards () {
      const cards = []
      const len = Math.max(this.colOne.length, this.colTwo.length)
      for (let i = 0; i < len; i++) {
        if (this.colOne[i]) cards.push(this.colOne[i])
        if (this.colTwo[i]) cards.push(this.colTwo[i])
      }
      return cards
    }
  },

  mounted () {
    window.addEventListener('scroll', this.onScroll, { passive: true })
    this.onScroll()
  },

  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
  },

  methods: {
    onScroll () {
      if (this.ticking) return
      this.ticking = true
      const self = this
      requestAnimationFrame(function () {
        self.updateParallax()
        self.ticking = false
      })
    },

    updateParallax () {
      const banner = this.$refs.banner
      if (!banner) return

      const rect    = banner.getBoundingClientRect()
      const windowH = window.innerHeight

      if (rect.bottom < -200 || rect.top > windowH + 200) return

      const bannerCentre = rect.top + rect.height / 2
      const progress     = (windowH / 2 - bannerCentre) / windowH

      this.colOneOffset = progress * -100 * 2
      this.colTwoOffset = progress * 100 * 2
    }
  }
}
